Bingo.NavigationOffcanvas = {};

Bingo.NavigationOffcanvas.openNavigation = () => {
    $('.js-offCanvasMenu').addClass('-active');
    $('.js-backdrop').addClass('-active');
    $('html, body').addClass('overflow-hidden');
};

Bingo.NavigationOffcanvas.closeNavigation = () => {
    $('.js-offCanvasMenu').removeClass('-active');
    $('.js-backdrop').removeClass('-active');
    $('html, body').removeClass('overflow-hidden');
};

Bingo.NavigationOffcanvas.init = () => {
    $(document).on('click', '.js-header__menuToggler', () => {
        Bingo.NavigationOffcanvas.openNavigation();
    });
    $(document).on('click', '.js-offCanvasMenu__close, .js-backdrop', () => {
        Bingo.NavigationOffcanvas.closeNavigation();
    });
    $(window).resize(() => {
        if ($('.js-offCanvasMenu').hasClass('-active') && window.matchMedia('(min-width: 1200px)').matches) {
            Bingo.NavigationOffcanvas.closeNavigation();
        }
    });
};
